import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";
import { Shield, Zap, Lock, Sparkles, Heart } from "lucide-react";

export const Route = createFileRoute("/de/about")({
  head: () => ({
    meta: [
      { title: "Über uns — Picamini.online" },
      {
        name: "description",
        content:
          "Lernen Sie die Mission von Picamini.online kennen: schnelle, datenschutzkonforme und kostenlose Unterrichts- und Entscheidungstools für Lehrkräfte, Schüler und Veranstalter weltweit.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/de/ueber-uns" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/about" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/sobre-nosotros" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/ueber-uns" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/about" },
    ],
  }),
  component: DeAboutPage,
});

function DeAboutPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="de" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="text-center space-y-3">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 border border-primary/20 px-4 py-1 text-xs font-bold text-primary">
            <Sparkles className="size-3.5" /> Über Picamini.online
          </span>
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">
            Kostenlose & private digitale Werkzeuge für alle
          </h1>
          <p className="text-base text-muted-foreground leading-relaxed">
            Wir glauben, dass Bildungstechnologie schnell, barrierefrei und streng datenschutzkonform sein muss.
          </p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-4">
          <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
            <Heart className="size-5 text-primary" /> Unsere Mission
          </h2>
          <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
            Picamini.online wurde mit dem Ziel entwickelt, Lehrkräften, Schülerinnen und Schülern sowie Moderatoren ein Paket aus schnellen digitalen Werkzeugen an die Hand zu geben — komplett ohne lästige Werbung oder Registrierungszwang. Von Zufalls-Namensgeneratoren bis hin zu PDF-Konvertern funktioniert alles direkt im Browser.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-3">
          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Zap className="size-6 text-amber-500" />
            <h3 className="font-bold text-foreground">100% Kostenlos</h3>
            <p className="text-xs text-muted-foreground">Keine Abos, keine versteckten Limits, keine Kosten.</p>
          </div>

          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Lock className="size-6 text-emerald-500" />
            <h3 className="font-bold text-foreground">Datenschutz Zuerst</h3>
            <p className="text-xs text-muted-foreground">Namenslisten & PDFs bleiben lokal auf Ihrem Gerät.</p>
          </div>

          <div className="p-6 rounded-2xl border bg-card space-y-2">
            <Shield className="size-6 text-blue-500" />
            <h3 className="font-bold text-foreground">Ohne Anmeldung</h3>
            <p className="text-xs text-muted-foreground">Sofort einsatzbereit ohne Registrierung oder Konto.</p>
          </div>
        </div>
      </main>

      <SiteFooter lang="de" />
    </div>
  );
}
